/**
 * Auth Form Schemas med Zod
 * Validering för login, signup, etc.
 */

import { z } from 'zod';

/**
 * Login form schema
 */
export const loginFormSchema = z.object({
  email: z
    .string()
    .min(1, 'Email krävs')
    .email('Ogiltig email-adress'),
  password: z.string().optional(),
});

export type LoginFormData = z.infer<typeof loginFormSchema>;

/**
 * Signup form schema
 */
export const signUpFormSchema = z
  .object({
    first_name: z.string().trim().min(2, 'Förnamn måste vara minst 2 tecken'),
    last_name: z.string().trim().min(2, 'Efternamn måste vara minst 2 tecken'),
    email: z.string().trim().email('Ogiltig email-adress'),
    password: z
      .string()
      .min(8, 'Lösenordet måste vara minst 8 tecken')
      .regex(/[A-Z]/, 'Lösenordet måste innehålla minst en stor bokstav')
      .regex(/[a-z]/, 'Lösenordet måste innehålla minst en liten bokstav')
      .regex(/\d/, 'Lösenordet måste innehålla minst en siffra')
      .regex(/[^a-zA-Z\d]/, 'Lösenordet måste innehålla minst ett specialtecken'),
    confirmPassword: z.string(),
    tos_accept: z.boolean().refine((val) => val === true, {
      message: 'Du måste acceptera villkoren',
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Lösenorden matchar inte',
    path: ['confirmPassword'],
  });

export type SignUpFormData = z.infer<typeof signUpFormSchema>;

